import React, { useState, useEffect, useRef } from "react";
import BackgroundVideo from "../components/home/backgroundvideo";
import BgVidIcons from "../components/home/backgroundVideoIcons";
import AboutCommunity from "../components/home/aboutCommunity";
import OurPurpose from "../components/home/ourPurpose";
import FreshmanSpotlight from "../components/home/freshmanSpotlight";
import GetInvolved from "../components/home/getInvolved";
import { Helmet } from "react-helmet";
import NextEventBanner from "../components/home/NextEventBanner";
import GraduateSpotlight from "../components/home/graduateSpotlight";
import CanvaPreview from "../components/home/bookletPreview";
import { useSiteContent } from "../hooks/useSiteContent";
import { getImageSrc } from "../utils/imageSrc";

const WebsiteTitle: React.FC<{ onGetInvolvedClick: () => void }> = ({
  onGetInvolvedClick,
}) => {
  const content = useSiteContent(
    ["home_hero_title", "home_hero_subtitle", "home_hero_cta"],
    {
      home_hero_title: "PERMIAS UIUC",
      home_hero_subtitle: "Welcome to Our Official Website",
      home_hero_cta: "Get Involved!",
    }
  );

  return (
    <div className="relative flex justify-center h-full">
      <div className="mt-[50px] flex flex-col">
        <span className="text-5xl font-bold md:text-7xl">
          {content.home_hero_title}
        </span>
        <span className="md:text-xl mt-[10px]">
          {content.home_hero_subtitle}
        </span>
      </div>
      <div className="absolute bottom-0 flex justify-center items-center mb-[10px] flex-col space-y-[20px]">
        <BgVidIcons />
        <button
          className="bg-transparent border-none cursor-pointer"
          onClick={onGetInvolvedClick}
        >
          <div className="text-white underline hover:text-white">
            {content.home_hero_cta}
          </div>
        </button>
      </div>
    </div>
  );
};

const HomePage: React.FC = () => {
  const bottomRef = useRef<HTMLDivElement>(null);
  const [showMascot, setShowMascot] = useState(false);

  const content = useSiteContent(
    ["home_mascot_image_url", "home_bg_video_url"],
    {
      home_mascot_image_url: "/Home/mascot.png",
      home_bg_video_url: "/Home/backgroundvid.mp4",
    }
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMascot(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleMascotClick = () => {
    setShowMascot(false);
  };

  return (
    <div>
      <Helmet>
        <meta
          name="description"
          content="Learn more about Permias UIUC, our mission, history, and how we connect Indonesian culture with UIUC"
        />
        <title>Permias UIUC</title>
      </Helmet>
      <div className="mb-[100px] w-full overflow-x-hidden">
        <div
          className={`fixed bottom-0 left-0 z-50 transition-transform duration-500 ease-out cursor-pointer ${
            showMascot ? "translate-y-0" : "translate-y-full"
          }`}
          onClick={handleMascotClick}
        >
          <img
            src={getImageSrc(content.home_mascot_image_url)}
            alt="Mascot"
            className="object-contain w-24 h-24 md:w-32 md:h-32 lg:w-40 lg:h-40"
          />
        </div>
        <div>
          <BackgroundVideo source={getImageSrc(content.home_bg_video_url)}>
            <WebsiteTitle onGetInvolvedClick={scrollToBottom} />
          </BackgroundVideo>
        </div>
        <div className="flex items-center justify-center w-full">
          <div className="w-full mt-[70px] md:mt-[120px] flex flex-col items-center px-[30px] md:px-[150px]">
            <AboutCommunity />
            <NextEventBanner />
            <div className="mt-[100px]">
              <OurPurpose />
            </div>
            <div className="mt-[140px] md:mx-[150px] mx-[20px]">
              <GraduateSpotlight />
            </div>
            <div className="mt-[140px] md:mb-[100px]">
              <CanvaPreview />
            </div>
            <div className="mt-[140px] md:mx-[150px] mx-[20px]">
              <FreshmanSpotlight />
            </div>
            <div className="mt-[120px]">
              <GetInvolved />
            </div>
          </div>
        </div>
      </div>
      <div ref={bottomRef}></div>
    </div>
  );
};

export default HomePage;
